import type {PropsWithChildren} from 'react'
import {createContext, useContext} from 'react'

import type {AppConfig} from '../types'

export type Point = [number, number]

type ConfigProviderProps = PropsWithChildren<AppConfig>

export const ConfigContext = createContext<AppConfig | null>(null)

export const ConfigProvider = ({children, ...contextValue}: ConfigProviderProps) => (
  <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>
)

export function useConfigContext(): AppConfig {
  const context = useContext(ConfigContext)

  if (!context) {
    throw new Error('useConfigContext has to be used within ConfigProvider')
  }

  return context
}
